import React, { useEffect, useState } from 'react';
import { outreachService } from '../../../services/outreachService';

const REASONS = ['unsubscribe', 'hard_bounce', 'complaint', 'manual'];

export function AddSuppressionModal({ onClose, onSaved }) {
  const [mode, setMode] = useState('email'); // 'email' or 'domain'
  const [value, setValue] = useState('');
  const [reason, setReason] = useState('manual');
  const [notes, setNotes] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    function onKey(e) { if (e.key === 'Escape') onClose(); }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  async function submit(e) {
    e.preventDefault();
    if (!value.trim()) { setError('Enter an email or domain.'); return; }
    setSubmitting(true);
    setError(null);
    try {
      await outreachService.addSuppression({
        email: mode === 'email' ? value.trim() : undefined,
        domain: mode === 'domain' ? value.trim() : undefined,
        reason,
        notes: notes.trim() || undefined,
      });
      onSaved();
    } catch (err) {
      setError(err.response?.data?.detail || err.message || 'Failed');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <form onSubmit={submit} className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-lg font-semibold mb-4">Add suppression entry</h2>

        <div className="flex gap-4 mb-3">
          <label className="flex items-center gap-1 text-sm">
            <input type="radio" name="mode" checked={mode === 'email'} onChange={() => setMode('email')} />
            Email
          </label>
          <label className="flex items-center gap-1 text-sm">
            <input type="radio" name="mode" checked={mode === 'domain'} onChange={() => setMode('domain')} />
            Whole domain
          </label>
        </div>

        <input
          type="text"
          placeholder={mode === 'email' ? 'shop@example.com' : 'example.com'}
          value={value}
          onChange={e => { setValue(e.target.value); if (error) setError(null); }}
          className="w-full border rounded px-2 py-2 mb-3 font-mono text-sm border-border-strong"
          autoFocus
        />

        <label className="block text-sm mb-1">Reason</label>
        <select value={reason} onChange={e => setReason(e.target.value)}
          className="w-full border rounded px-2 py-2 mb-3 text-sm border-border-strong">
          {REASONS.map(r => <option key={r} value={r}>{r}</option>)}
        </select>

        <label className="block text-sm mb-1">Notes (optional)</label>
        <textarea value={notes} onChange={e => setNotes(e.target.value)}
          rows={2} className="w-full border rounded px-2 py-2 mb-3 text-sm border-border-strong" />

        {error && <div className="text-danger text-sm mb-2">{error}</div>}

        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose}
            className="px-3 py-2 text-sm bg-surface-sunken hover:bg-surface-sunken/80 rounded">Cancel</button>
          <button type="submit" disabled={submitting}
            className="px-3 py-2 text-sm bg-accent text-white hover:bg-accent-hover rounded disabled:opacity-50">
            {submitting ? 'Saving…' : 'Save'}
          </button>
        </div>
      </form>
    </div>
  );
}
